const Conf= {
  apiUrl:'https://lelait-admin-dev.lefil.org',
  authToken: 'BmaPfdnHmQjVgNd4xAeU',
  perPage:6,
}
export default Conf;
